"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Views = exports.EventMenu = exports.GlobalMenu = void 0;
const acl_1 = require("../acl");
const GlobalCRMMain = [
    "crm:c" /* scope.CRM.Create */,
    "crm:d" /* scope.CRM.Delete */,
    "crm:r" /* scope.CRM.Read */,
    "crm:u" /* scope.CRM.Update */,
];
exports.GlobalMenu = {
    Events: {
        Main: [
            "evt:c" /* scope.Event.Create */,
            "evt:d" /* scope.Event.Delete */,
            "evt:r" /* scope.Event.Read */,
            "evt:u" /* scope.Event.Update */,
        ],
        SubMenu: {
            EventSeries: [
                "ser:c" /* scope.EventSeries.Create */,
                "ser:d" /* scope.EventSeries.Delete */,
                "ser:p" /* scope.EventSeries.Publish */,
                "ser:r" /* scope.EventSeries.Read */,
                "ser:u" /* scope.EventSeries.Update */,
            ],
        },
    },
    CRM: {
        Main: GlobalCRMMain,
    },
    Documents: {
        Main: ["crm:c" /* scope.CRM.Create */, "crm:u" /* scope.CRM.Update */],
    },
    EmailMarketing: {
        Main: [
            "ctp:r" /* scope.CRMEmail.ReadTemplate */,
            "ctp:u" /* scope.CRMEmail.UpdateTemplate */,
            "ctp:c" /* scope.CRMEmail.CreateTemplate */,
            "ctp:d" /* scope.CRMEmail.DeleteTemplate */,
            "ctp:p" /* scope.CRMEmail.PublishTemplate */,
            "cmc:r" /* scope.CRMEmail.ReadCampaign */,
            "cmc:u" /* scope.CRMEmail.UpdateCampaign */,
            "cmc:c" /* scope.CRMEmail.CreateCampaign */,
            "cmc:d" /* scope.CRMEmail.DeleteCampaign */,
        ],
        SubMenu: {
            EmailCampaigns: [
                "cmc:r" /* scope.CRMEmail.ReadCampaign */,
                "cmc:u" /* scope.CRMEmail.UpdateCampaign */,
                "cmc:c" /* scope.CRMEmail.CreateCampaign */,
                "cmc:d" /* scope.CRMEmail.DeleteCampaign */,
            ],
        },
    },
    Integrations: {
        All: [],
        Integrations: [
            ...acl_1.IntegrationScopes.canCreate,
            ...acl_1.IntegrationScopes.canDelete,
            ...acl_1.IntegrationScopes.canRead,
            ...acl_1.IntegrationScopes.canUpdate,
        ],
        GlobalProcesses: [
            ...acl_1.GlobalProcessScopes.canCreate.Contact,
            ...acl_1.GlobalProcessScopes.canCreate.Event,
            ...acl_1.GlobalProcessScopes.canCreate.Organization,
            ...acl_1.GlobalProcessScopes.canCreate.Participant,
            ...acl_1.GlobalProcessScopes.canDelete.Contact,
            ...acl_1.GlobalProcessScopes.canDelete.Event,
            ...acl_1.GlobalProcessScopes.canDelete.Organization,
            ...acl_1.GlobalProcessScopes.canDelete.Participant,
            ...acl_1.GlobalProcessScopes.canInterrupt.Contact,
            ...acl_1.GlobalProcessScopes.canInterrupt.Event,
            ...acl_1.GlobalProcessScopes.canInterrupt.Organization,
            ...acl_1.GlobalProcessScopes.canInterrupt.Participant,
            ...acl_1.GlobalProcessScopes.canPause.Contact,
            ...acl_1.GlobalProcessScopes.canPause.Event,
            ...acl_1.GlobalProcessScopes.canPause.Organization,
            ...acl_1.GlobalProcessScopes.canPause.Participant,
            ...acl_1.GlobalProcessScopes.canRead.Contact,
            ...acl_1.GlobalProcessScopes.canRead.Event,
            ...acl_1.GlobalProcessScopes.canRead.Organization,
            ...acl_1.GlobalProcessScopes.canRead.Participant,
            ...acl_1.GlobalProcessScopes.canUpdate.Contact,
            ...acl_1.GlobalProcessScopes.canUpdate.Event,
            ...acl_1.GlobalProcessScopes.canUpdate.Organization,
            ...acl_1.GlobalProcessScopes.canUpdate.Participant,
        ],
        EmailTemplates: [
            ...acl_1.GlobalEventEmailTemplateScopes.canCreate,
            ...acl_1.GlobalEventEmailTemplateScopes.canRead,
        ],
    },
    TicketsAndProducts: {
        Main: [
            "fin:c" /* scope.Financial.Create */,
            "fin:r" /* scope.Financial.Read */,
            "fin:u" /* scope.Financial.Update */,
            "fin:d" /* scope.Financial.Delete */,
        ],
    },
    FieldsManager: {
        Main: [
            ...GlobalCRMMain,
            "cf:c" /* scope.ContactField.Create */,
            "cf:u" /* scope.ContactField.Update */,
            "cf:r" /* scope.ContactField.Read */,
            "of:c" /* scope.OrganizationField.Create */,
            "of:u" /* scope.OrganizationField.Update */,
            "of:r" /* scope.OrganizationField.Read */,
        ],
    },
    Reports: {
        Main: [
            "rprt:c" /* scope.Report.Create */,
            "rprt:d" /* scope.Report.Delete */,
            "rprt:r" /* scope.Report.Read */,
            "rprt:u" /* scope.Report.Update */,
        ],
    },
    Theme: {
        Main: [
            "thm:c" /* scope.Theme.Create */,
            "thm:d" /* scope.Theme.Delete */,
            "thm:r" /* scope.Theme.Read */,
            "thm:u" /* scope.Theme.Update */,
            "evp:u" /* scope.EventPage.Update */,
            "evp:c" /* scope.EventPage.Create */,
        ],
    },
    RoomsManagement: {
        Main: [
            "rmm:c" /* scope.RoomManagement.Create */,
            "rmm:r" /* scope.RoomManagement.Read */,
            "rmm:u" /* scope.RoomManagement.Update */,
            "rmm:d" /* scope.RoomManagement.Delete */,
        ],
    },
    Organization: {
        Main: GlobalCRMMain,
    },
    Project: {
        Main: [
            ...acl_1.ProjectScopes.canRead,
            ...acl_1.ProjectScopes.canCreate,
            ...acl_1.ProjectScopes.canUpdate,
            ...acl_1.ProjectScopes.canDelete,
        ],
    },
};
exports.GlobalMenu.Integrations.All = [
    ...exports.GlobalMenu.Integrations.Integrations,
    ...exports.GlobalMenu.Integrations.GlobalProcesses,
    ...exports.GlobalMenu.Integrations.EmailTemplates,
];
exports.EventMenu = {
    Website: {
        Main: [
            "evp:c" /* scope.EventPage.Create */,
            "ast:c" /* scope.EventPage.CreateAsset */,
            "evp:d" /* scope.EventPage.Delete */,
            "ast:d" /* scope.EventPage.DeleteAsset */,
            "evp:p" /* scope.EventPage.Publish */,
            "evp:r" /* scope.EventPage.Read */,
            "ast:r" /* scope.EventPage.ReadAsset */,
            "evp:u" /* scope.EventPage.Update */,
            "ast:u" /* scope.EventPage.UpdateAsset */,
        ],
        SubMenu: {},
    },
    FieldsManager: {
        Main: [
            "lef:c" /* scope.EventField.CreateLocal */,
            "lef:d" /* scope.EventField.DeleteLocal */,
            "lef:u" /* scope.EventField.UpdateLocal */,
            "epf:c" /* scope.ParticipantField.Create */,
            "epf:d" /* scope.ParticipantField.Delete */,
            "epf:r" /* scope.ParticipantField.Read */,
            "epf:u" /* scope.ParticipantField.Update */,
        ],
    },
    Documents: {
        Main: [
            "asc:c" /* scope.CRMEmail.CreateAsset */,
            "asc:r" /* scope.CRMEmail.ReadAsset */,
            "asc:u" /* scope.CRMEmail.UpdateAsset */,
            "asc:d" /* scope.CRMEmail.DeleteAsset */,
        ],
    },
    EmailMarketing: {
        Main: [
            "asc:c" /* scope.EventEmail.CreateAsset */,
            "cmp:c" /* scope.EventEmail.CreateCampaign */,
            "etp:c" /* scope.EventEmail.CreateTemplate */,
            "asc:d" /* scope.EventEmail.DeleteAsset */,
            "cmp:d" /* scope.EventEmail.DeleteCampaign */,
            "etp:d" /* scope.EventEmail.DeleteTemplate */,
            "etp:p" /* scope.EventEmail.PublishTemplate */,
            "asc:r" /* scope.EventEmail.ReadAsset */,
            "cmp:r" /* scope.EventEmail.ReadCampaign */,
            "etp:r" /* scope.EventEmail.ReadTemplate */,
            "mail:s" /* scope.EventEmail.SendMail */,
            "asc:u" /* scope.EventEmail.UpdateAsset */,
            "cmp:u" /* scope.EventEmail.UpdateCampaign */,
            "etp:u" /* scope.EventEmail.UpdateTemplate */,
        ],
    },
    Activities: {
        Main: [
            "act:c" /* scope.Activity.Create */,
            "act:r" /* scope.Activity.Read */,
            "act:u" /* scope.Activity.Update */,
            "act:d" /* scope.Activity.Delete */,
        ],
    },
    Workflows: {
        Main: [
            "prc:c" /* scope.ParticipantProcess.Create */,
            "prc:d" /* scope.ParticipantProcess.Delete */,
            "prc:i" /* scope.ParticipantProcess.Interrupt */,
            "prc:p" /* scope.ParticipantProcess.Pause */,
            "prc:r" /* scope.ParticipantProcess.Read */,
            "prc:ul" /* scope.ParticipantProcess.Update */,
            "prc:u" /* scope.ParticipantProcess.UpdateAndControl */,
        ],
        SubMenu: {
            WorkflowAutomations: [
                "prc:c" /* scope.ParticipantProcess.Create */,
                "prc:d" /* scope.ParticipantProcess.Delete */,
                "prc:i" /* scope.ParticipantProcess.Interrupt */,
                "prc:p" /* scope.ParticipantProcess.Pause */,
                "prc:r" /* scope.ParticipantProcess.Read */,
                "prc:ul" /* scope.ParticipantProcess.Update */,
                "prc:u" /* scope.ParticipantProcess.UpdateAndControl */,
                "stg:c" /* scope.Stage.Create */,
                "stg:d" /* scope.Stage.Delete */,
                "stg:r" /* scope.Stage.Read */,
                "stg:u" /* scope.Stage.Update */,
            ],
            Stages: [
                "stg:c" /* scope.Stage.Create */,
                "stg:d" /* scope.Stage.Delete */,
                "stg:r" /* scope.Stage.Read */,
                "stg:u" /* scope.Stage.Update */,
            ],
            Processes: [
                "prc:u" /* scope.ParticipantProcess.UpdateAndControl */,
                "prc:d" /* scope.ParticipantProcess.Delete */,
                "prc:r" /* scope.ParticipantProcess.Read */,
            ],
        },
    },
    TicketsAndProducts: {
        Main: [
            "fin:c" /* scope.Financial.Create */,
            "fin:r" /* scope.Financial.Read */,
            "fin:u" /* scope.Financial.Update */,
            "fin:d" /* scope.Financial.Delete */,
        ],
        SubMenu: {
            PaymentSettings: ["evt:c" /* scope.Event.Create */, "evt:f" /* scope.Event.ManageFinances */],
        },
    },
    Reports: {
        Main: [
            "rprtl:c" /* scope.Report.CreateLocal */,
            "rprtl:d" /* scope.Report.DeleteLocal */,
            "rprtl:r" /* scope.Report.ReadLocal */,
            "rprtl:u" /* scope.Report.UpdateLocal */,
        ],
    },
};
exports.Views = {
    Partcipant: [
        "evt:v" /* scope.Event.View */,
    ],
    Event: ["evt:v" /* scope.Event.View */],
    CRM: ["crm:v" /* scope.CRM.View */],
};
